export default {
  logOut: {
    color: '#C82832'
  },
  logOutIcon: {
    marginRight: '5px'
  }
};
